import React from "react";


function Index() {

  window.location.href = "https://terms.metalordz.com";
  return (
      <div></div>
  );
}

export default Index;
